import {RateMasterList} from "./RateMasterList";
import {RateMasterEdit} from "./RateMasterEdit";
import {RateMasterCreate} from "./RateMasterCreate";

export default {
    list: RateMasterList,
    create: RateMasterCreate,
    edit: RateMasterEdit
};
